import { render, staticRenderFns } from "./ArgDetail.vue?vue&type=template&id=65e51f0f&scoped=true&"
import script from "./ArgDetail.vue?vue&type=script&lang=js&"
export * from "./ArgDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e51f0f",
  null
  
)

export default component.exports